module.exports = __webpack_public_path__ + "img/3.e5392864.jpg";